import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { createClient } from 'pexels';
import * as actions from '../redux/actions';
import CustomLoader from '../../common/CustomLoader';
import voca from 'voca';

export class AssetSearch extends Component {
  static propTypes = {
    editor: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
  };
  state = {
    photos: [],
    isSearching: false,
    searchKey: '',
    per_page: 12,
    page: 0,
    total_results: 0,
    showing_result: 0,
    selectedImage: '',
    selectedImageId: '',
    photoSizeOptions: [],
    noKeyEnteredMessage: '',
    size: 'small',
  };

  handleSearchInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value, noKeyEnteredMessage: '' });
  };

  showCard = () => {
    return {
      display: !this.props.editor.toggleAssetSearch ? 'none' : '',
    };
  };

  selectImageSrc = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };

  selectImageToUpload = (imageId) => {
    const { selectedImageId, photos } = this.state;
    const selectedPhoto = photos.find((photo) => photo.id === imageId);
    if (selectedImageId !== imageId) {
      let defaultSelectedSize = '';
      let photoSizeOptions = [];
      Object.keys(selectedPhoto.src).forEach((imageKey, i) => {
        defaultSelectedSize = i === 2 ? imageKey : defaultSelectedSize;
        photoSizeOptions.push({
          label: voca.capitalize(imageKey),
          value: selectedPhoto.src[imageKey],
        });
      });
      defaultSelectedSize = defaultSelectedSize ? defaultSelectedSize : 'original';
      let selectedImage = selectedPhoto.src[defaultSelectedSize];
      this.setState({
        selectedImageId: imageId,
        selectedImage,
        photoSizeOptions,
      });
    } else {
      this.setState({ selectedImageId: '', selectedImage: '', photoSizeOptions: [] });
    }
  };

  uploadImage = () => {
    const { projectId, version } = this.props;
    this.props.actions.uplodSearchedImage({
      projectId,
      version,
      selectedImages: [this.state.selectedImage],
    });
    this.setState({
      selectedImage: '',
      selectedImageId: '',
      photoSizeOptions: [],
    });
  };

  showSelectSize = () => {
    const { selectedImageId, photoSizeOptions, selectedImage } = this.state;
    if (selectedImageId && photoSizeOptions) {
      return (
        <select
          name="selectedImage"
          className="form-control form-control-sm"
          onChange={this.selectImageSrc}
          value={selectedImage}
        >
          <option value="">Choose Size to Upload</option>
          {photoSizeOptions.map((option) => (
            <option value={option.value} key={option.label}>
              {option.label}
            </option>
          ))}
        </select>
      );
    }
  };

  showUploadButton = () => {
    const { selectedImage } = this.state;
    if (selectedImage) {
      return (
        <button
          type="button"
          className="btn btn-sm btn-theme-submit"
          onClick={this.uploadImage}
          disabled={this.props.editor.showImageUploadLoader}
        >
          <i className="wb webconnect-upload"></i> Add Image to Assets Library
        </button>
      );
    }
  };

  searchImage = async () => {
    const { per_page, searchKey, size } = this.state;
    if (!searchKey) {
      this.setState({ noKeyEnteredMessage: 'Please enter key to search' });
      return;
    }
    this.setState({ isSearching: true });
    const client = createClient(process.env.REACT_APP_PEXELS_API_KEY);
    const page = 1;
    const searchResponse = await client.photos.search({
      query: searchKey,
      size,
      per_page,
      page,
    });

    const { photos, total_results } = searchResponse;
    this.setState({
      photos,
      total_results,
      showing_result: photos.length,
      page,
      isSearching: false,
      noKeyEnteredMessage: photos.length === 0 ? 'No image has been found.' : '',
    });
  };

  nextPage = async () => {
    const client = createClient(process.env.REACT_APP_PEXELS_API_KEY);
    let { per_page, page, showing_result, size } = this.state;
    page++;
    const searchResponse = await client.photos.search({
      query: this.state.searchKey,
      size,
      per_page,
      page: page,
    });

    const { photos } = searchResponse;
    this.setState({ photos, page, showing_result: showing_result + photos.length });
  };

  prevPage = async () => {
    const client = createClient(process.env.REACT_APP_PEXELS_API_KEY);
    let { size, per_page, page, showing_result } = this.state;
    page--;
    const searchResponse = await client.photos.search({
      query: this.state.searchKey,
      size,
      per_page,
      page: page,
    });

    const { photos } = searchResponse;
    this.setState({ photos, page, showing_result: showing_result - photos.length });
  };

  render() {
    const {
      photos,
      total_results,
      showing_result,
      selectedImageId,
      isSearching,
      noKeyEnteredMessage,
    } = this.state;
    return (
      <div className="gjs-mdl-container" style={this.showCard()}>
        <div className="gjs-mdl-dialog gjs-one-bg gjs-two-color">
          <div className="gjs-mdl-header">
            <div className="gjs-mdl-title">Search Image</div>
            <div
              className="gjs-mdl-btn-close"
              onClick={this.props.actions.toggleAssetSearch}
              data-close-modal=""
            >
              ⨯
            </div>
          </div>
          <div className="gjs-mdl-content">
            <div id="gjs-mdl-c">
              <div className="row">
                <div className="col-sm-10 col-xs-10 col-md-10 col-lg-10 text-right">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    name="searchKey"
                    placeholder="Eg: Cat"
                    value={this.state.searchKey}
                    onChange={this.handleSearchInputChange}
                  />
                </div>
                <div className="col-2 text-right">
                  <button
                    type="button"
                    className="btn btn-sm btn-theme-submit"
                    disabled={isSearching}
                    onClick={this.searchImage}
                  >
                    <i className="wb webconnect-search"></i> Search&nbsp;
                    <CustomLoader loading={isSearching} />
                  </button>
                </div>
              </div>
              <div className="row pt-5 text-center" style={{ minHeight: '10rem' }}>
                <CustomLoader
                  css={{
                    margin: '0',
                    display: 'inline-block',
                    height: '1vh',
                    marginLeft: '400px',
                    marginBottom: '10rem',
                  }}
                  size="15px"
                  loading={isSearching}
                />

                {noKeyEnteredMessage ? (
                  <div className="px-3 pb-5 text-center" style={{ minHeight: '10rem' }}>
                    <p>{noKeyEnteredMessage}</p>
                  </div>
                ) : (
                  ''
                )}

                {!isSearching &&
                  !noKeyEnteredMessage &&
                  photos.map((photo) => (
                    <div className="col-xs-6 col-sm-3 col-md-3 text-center" key={photo.id}>
                      <label
                        className="image-checkbox"
                        onClick={() => this.selectImageToUpload(photo.id)}
                      >
                        <img
                          src={photo.src.tiny}
                          alt={photo.photographer_id}
                          className="pexels-image-list pix-image"
                        />
                        <i
                          className={`wb webconnect-check ${
                            selectedImageId !== photo.id ? 'hidden' : ''
                          }`}
                        ></i>
                        <div className="pix-middle">
                          <div className="pix-text">Select Image</div>
                        </div>
                      </label>
                    </div>
                  ))}
              </div>

              {!isSearching && !noKeyEnteredMessage ? (
                <div className="row mt-2 py-2">
                  <div className="col-md-3 text-left">
                    {total_results ? `showing ${showing_result} of ${total_results}` : ''}
                  </div>
                  <div className="col-md-3">{this.showSelectSize()}&nbsp;</div>
                  <div className="col-md-4">
                    {this.showUploadButton()}
                    <CustomLoader loading={this.props.editor.showImageUploadLoader} size="15px" />
                  </div>
                  <div className="col-md-2 text-right">
                    {showing_result > 0 && showing_result !== total_results ? (
                      <button
                        type="button"
                        className="btn btn-theme-submit btn-sm"
                        onClick={this.prevPage}
                      >
                        <i className="wb webconnect-angle-double-left"></i> Prev
                      </button>
                    ) : (
                      ''
                    )}
                    &nbsp;
                    {showing_result < total_results ? (
                      <button
                        className="btn btn-theme-submit btn-sm"
                        type="button"
                        onClick={this.nextPage}
                      >
                        Next <i className="wb webconnect-angle-double-right"></i>
                      </button>
                    ) : (
                      ''
                    )}
                    &nbsp;
                  </div>
                </div>
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    editor: state.editor,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetSearch);
